import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarCheck, Calculator } from "lucide-react";

const HIDDEN = ["/book-a-demo", "/thank-you", "/admin", "/investor", "/r/"];

export default function StickyMobileCta() {
  const { pathname } = useLocation();
  if (HIDDEN.some((p) => pathname.startsWith(p))) return null;
  return (
    <>
      <div className="h-20 md:hidden" aria-hidden="true" />
      <div className="fixed inset-x-0 bottom-0 z-50 md:hidden border-t border-border bg-background/90 backdrop-blur-xl px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]" data-testid="sticky-mobile-cta">
        <div className="flex gap-2">
          <Link to="/roi-calculator" className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-md border border-border py-3 text-sm font-medium text-foreground" data-testid="sticky-cta-roi">
            <Calculator className="h-4 w-4" /> ROI
          </Link>
          <Link to="/book-a-demo" className="flex-[2] inline-flex items-center justify-center gap-1.5 rounded-md bg-primary py-3 text-sm font-semibold text-primary-foreground" data-testid="sticky-cta-demo">
            <CalendarCheck className="h-4 w-4" /> Book a walkthrough
          </Link>
        </div>
      </div>
    </>
  );
}
